import * as firebase from 'firebase';
//import firestore from 'firebase/firestore'  

var firebaseConfig = {
    apiKey: "AIzaSyCAe99ai3HWJfucGXbbC0dlnlHdFJvYPec",
    authDomain: "paper-chat-92511.firebaseapp.com",
    databaseURL: "https://paper-chat-92511.firebaseio.com",
    projectId: "paper-chat-92511",
    storageBucket: "paper-chat-92511.appspot.com",
    messagingSenderId: "257020232151",
    appId: "1:257020232151:web:f8660187d54d73d84b4b92",
    measurementId: "G-V67J73MCFC"
  };


  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics()
  firebase.firestore()  

 // var database = firebase.database();



export default firebase